///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { CustomerIdWithNameProjection } from '../../generated/shared-types.model';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProjectMoveService {
    private readonly fetchUrl = 'api/project';
    private readonly modifyUrl = 'api/project';

    constructor(private readonly http: HttpClient) {}

    getCompaniesToMove(projectId: number): Observable<CustomerIdWithNameProjection[]> {
        return this.http.get<CustomerIdWithNameProjection[]>(`${this.fetchUrl}/light-list/${projectId}`).pipe(catchError(() => of([])));
    }

    validateMoveProject(projectId: number, companyToMoveId: number): Observable<string> {
        return this.http
            .get(`${this.modifyUrl}/${projectId}/${companyToMoveId}/validate-move`, { responseType: 'text' })
            .pipe(catchError(() => of(undefined)));
    }

    moveProject(projectId: number, companyToMoveId: number, parentId: number): Observable<boolean> {
        return this.http
            .post<boolean>(`${this.modifyUrl}/${projectId}/${companyToMoveId}/${parentId}/move`, {})
            .pipe(catchError(() => of(false)));
    }
}
